import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";

export class Room extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      roomList: [],
      roomSelected: false,
      roomEdited: false,
      roomAdded: false,
      roomDeleted: false,
      selectedRoom: "",
      selectedRoomId: "",
      selectedRoomLastUpdatedDateTime: "",
      selectedRoomName: "",
      selectedRoomNumber: "",
      selectedRoomDescription: "",
      selectedRoomCapacity: ""
    };
  }

  componentDidMount = () => {
    this.getRooms();
  };

  getRooms = async () => {
    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");
    roomRequest.userId = localStorage.getItem("userId");

    await api("roomApiV1RoomGetByCodeTag", roomRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.roomList)) {
          res.data.roomList.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let roomResponse = Belfastpilatesappspotcom.RoomResponse.constructFromObject(
          res.data
        );
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState({ loaded: true, roomList: roomResponse.roomList });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Rooms could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("roomApiV1RoomGetByCodeTag has failed");
      }
    });
  };

  updateRoom = async () => {
    this.setState({ loaded: false });

    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");
    roomRequest.userId = localStorage.getItem("userId");
    roomRequest.id = this.state.selectedRoomId;
    roomRequest.lastUpdatedDateTime = this.state.selectedRoomLastUpdatedDateTime;
    roomRequest.name = this.state.editedRoomName;
    roomRequest.number = this.state.editedRoomNumber;
    roomRequest.description = this.state.editedRoomDescription;
    roomRequest.capacity = this.state.editedRoomCapacity;

    await api("roomApiV1RoomUpdate", roomRequest).then(res => {
      if (res.data) {
        let roomResponse = Belfastpilatesappspotcom.RoomResponse.constructFromObject(
          res.data
        );
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState(
            {
              loaded: true,
              roomSelected: true,
              roomEdited: false,
              roomAdded: false
            },
            () => {
              this.growl.show({
                severity: "success",
                summary: "Success",
                detail: "Room successfully updated"
              });
              this.getRooms();
            }
          );
        } else {
          this.setState(
            {
              loaded: true,
              roomSelected: true,
              roomEdited: true,
              roomAdded: false
            },
            () => {
              this.growl.show({
                severity: "error",
                summary: "Error",
                detail: "Room could not be updated, please try again"
              });
            }
          );
        }
      } else {
        console.log("roomApiV1RoomUpdate has failed");
      }
    });
  };

  addRoom = async () => {
    this.setState({ loaded: false });

    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");
    roomRequest.userId = localStorage.getItem("userId");
    roomRequest.name = this.state.editedRoomName;
    roomRequest.number = this.state.editedRoomNumber;
    roomRequest.description = this.state.editedRoomDescription;
    roomRequest.capacity = this.state.editedRoomCapacity;

    await api("roomApiV1RoomCreate", roomRequest).then(res => {
      if (res.data) {
        let roomResponse = Belfastpilatesappspotcom.RoomResponse.constructFromObject(
          res.data
        );
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState(
            {
              loaded: true,
              roomSelected: false,
              roomEdited: false,
              roomAdded: false
            },
            () => {
              this.growl.show({
                severity: "success",
                summary: "Success",
                detail: "Room successfully created"
              });
              this.getRooms();
            }
          );
        } else {
          this.setState(
            {
              loaded: true,
              roomSelected: false,
              roomEdited: true,
              roomAdded: true
            },
            () => {
              this.growl.show({
                severity: "error",
                summary: "Error",
                detail: "Room could not be created, please try again"
              });
            }
          );
        }
      } else {
        console.log("roomApiV1RoomCreate has failed");
      }
    });
  };

  deleteRoom = async () => {
    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");
    roomRequest.userId = localStorage.getItem("userId");
    roomRequest.id = this.state.selectedRoomId;
    roomRequest.lastUpdatedDateTime = this.state.selectedRoomLastUpdatedDateTime;

    await api("roomApiV1RoomDelete", roomRequest).then(res => {
      if (res.data) {
        let roomResponse = Belfastpilatesappspotcom.RoomResponse.constructFromObject(
          res.data
        );
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState(
            {
              loaded: true,
              roomSelected: false,
              roomEdited: false,
              roomAdded: false
            },
            () => {
              this.growl.show({
                severity: "success",
                summary: "Success",
                detail: "Room successfully deleted"
              });
              this.getRooms();
            }
          );
        } else {
          this.setState(
            {
              loaded: true,
              roomSelected: true,
              roomEdited: true,
              roomAdded: false
            },
            () => {
              this.growl.show({
                severity: "error",
                summary: "Error",
                detail: "Room could not be deleted, please try again"
              });
            }
          );
        }
      } else {
        console.log("roomApiV1RoomDelete has failed");
      }
    });
  };

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <div className="ui-g-12">
          <pr.Button
            label="Create Room"
            onClick={() => {
              this.setState({
                roomSelected: false,
                roomEdited: true,
                roomAdded: true,
                editedRoomName: "",
                editedRoomNumber: "",
                editedRoomDescription: "",
                editedRoomCapacity: ""
              });
            }}
            style={{ float: "right" }}
          />
        </div>
        <div className="ui-g-12">
          <pr.Dialog
            header="Delete Room"
            footer={
              <div>
                <pr.Button
                  label="Yes"
                  onClick={() => {
                    this.deleteRoom();
                    this.setState({
                      roomDeleted: false,
                      roomEdited: false,
                      roomSelected: false
                    });
                  }}
                  style={{ float: "right" }}
                />
                <pr.Button
                  label="No"
                  onClick={() => {
                    this.setState({ roomDeleted: false });
                  }}
                  style={{ float: "right" }}
                />
              </div>
            }
            visible={this.state.roomDeleted}
            style={{ width: "50vw" }}
            modal={true}
            onHide={e => this.setState({ roomDeleted: false })}
          >
            Are you sure you want to delete?
          </pr.Dialog>

          {!this.state.roomEdited ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        roomSelected: true,
                        roomEdited: false,
                        roomAdded: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={this.state.editedRoomName || ""}
                        onChange={e => {
                          this.setState({ editedRoomName: e.target.value });
                        }}
                      />
                      <label>Name</label>
                    </span>
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={
                          this.state.editedRoomNumber
                            ? this.state.editedRoomNumber.toString()
                            : ""
                        }
                        onChange={e => {
                          this.setState({ editedRoomNumber: e.target.value });
                        }}
                      />
                      <label>Number</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={this.state.editedRoomDescription || ""}
                        onChange={e => {
                          this.setState({
                            editedRoomDescription: e.target.value
                          });
                        }}
                      />
                      <label>Description</label>
                    </span>
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={
                          this.state.editedRoomCapacity
                            ? this.state.editedRoomCapacity.toString()
                            : ""
                        }
                        onChange={e => {
                          this.setState({ editedRoomCapacity: e.target.value });
                        }}
                      />
                      <label>Capacity</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Save"
                    onClick={() => {
                      if (this.state.roomAdded === true) {
                        this.addRoom();
                      } else {
                        this.updateRoom();
                      }
                    }}
                    style={{ float: "right" }}
                  />
                  {this.state.roomAdded === true ? (
                    <label />
                  ) : (
                    <pr.Button
                      label="Delete"
                      onClick={() => {
                        this.setState({ roomDeleted: true });
                      }}
                      style={{ float: "right" }}
                    />
                  )}
                  <pr.Button
                    label="Cancel"
                    onClick={() => {
                      this.setState({
                        roomSelected: true,
                        roomEdited: false,
                        roomAdded: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          )}

          {!this.state.roomSelected ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-pencil"
                    onClick={() => {
                      this.setState({
                        roomSelected: false,
                        roomEdited: true,
                        roomAdded: false,
                        editedRoomName: this.state.selectedRoomName,
                        editedRoomNumber: this.state.selectedRoomNumber,
                        editedRoomDescription: this.state
                          .selectedRoomDescription,
                        editedRoomCapacity: this.state.selectedRoomCapacity
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Name: </b>
                    <label>{this.state.selectedRoomName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Number: </b>
                    <label>{this.state.selectedRoomNumber || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Description: </b>
                    <label>
                      {this.state.selectedRoomDescription || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Capacity: </b>
                    <label>
                      {this.state.selectedRoomCapacity || "Not Set"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="ui-g card">
            <div className="ui-g-12">
              <pr.DataTable
                value={this.state.roomList}
                selectionMode="single"
                selection={this.state.selectedRoom}
                onSelectionChange={e => {
                  this.setState(
                    {
                      roomSelected: true,
                      roomEdited: false,
                      roomAdded: false,
                      selectedRoom: e.data,
                      selectedRoomId: e.data.id,
                      selectedRoomLastUpdatedDateTime:
                        e.data.lastUpdatedDateTime,
                      selectedRoomName: e.data.name,
                      selectedRoomNumber: e.data.number,
                      selectedRoomDescription: e.data.description,
                      selectedRoomCapacity: e.data.capacity
                    },
                    () => {
                      console.log(this.state.selectedRoom);
                    }
                  );
                }}
                header="Rooms"
                footer=" "
                autoLayout={true}
                paginator={false}
                alwaysShowPaginator={false}
                scrollable={true}
              >
                <pr.Column
                  field="name"
                  header="Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="number"
                  header="Number"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="description"
                  header="Description"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="capacity"
                  header="Capacity"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Room/Room.js